import type { MedicationPadItemType } from '@/components/PatientPageV2/components/PrescriptionPad/PrescriptionPad.types';
import type { StateCreator } from 'zustand';
import type { PrescriptionAssistantSliceType } from '../types';
import {
  getUpdateMedicationPadItems,
  updateReissueAndCancelWhenChangingProducts
} from '../utils/updateMedicationPadItems';

export const updateMedicationPadItemById: StateCreator<
  PrescriptionAssistantSliceType,
  [['zustand/immer', never], ['zustand/devtools', never]],
  [],
  (
    updatedMedicationPadItem: MedicationPadItemType,
    flags: {
      ffPatPrescriptionDosageMinLengthValidation: boolean;
    }
  ) => void
> =
  (set, get) =>
  (updatedMedicationPadItem, { ffPatPrescriptionDosageMinLengthValidation }) => {
    const { prescriptionAssistant, updatePrescriptionHistoryItemsToReissue, updatePrescriptionHistoryItemsToCancel } =
      get();
    // Update medication pad items
    const { updatedItems, previousProductId, updatedItem } = getUpdateMedicationPadItems(
      prescriptionAssistant.prescriptionPad.medicationPadItems,
      updatedMedicationPadItem,
      ffPatPrescriptionDosageMinLengthValidation,
      prescriptionAssistant.prescriptionHistory.previousItems
    );

    const {
      updatedCancelledItems,
      updatedReissuedItems,
      updatedMedicationPadItem: latestMedicationPadItem
    } = updateReissueAndCancelWhenChangingProducts(
      updatedItem ?? updatedMedicationPadItem,
      prescriptionAssistant.prescriptionHistory.previousItems,
      prescriptionAssistant.prescriptionHistory.itemsToReissue,
      prescriptionAssistant.prescriptionHistory.itemsToCancel,
      previousProductId
    );

    updatePrescriptionHistoryItemsToCancel(updatedCancelledItems);
    updatePrescriptionHistoryItemsToReissue(updatedReissuedItems);

    set(
      (state) => {
        state.prescriptionAssistant.prescriptionPad.medicationPadItems = updatedItems.map((item) => {
          if (item.medicationPadItemId === latestMedicationPadItem?.medicationPadItemId) {
            return latestMedicationPadItem;
          }
          return item;
        });
      },
      false,
      'prescriptionPad/updateMedicationPadItemById'
    );
  };
